import type { GambleStep } from "@slot/game-shell";

export const step01Win: GambleStep = {
  outcome: "win",
  multiplier: "2",
  serverChosenValue: "red",
  // base post-bet balance 100000 + newWin 400
  balanceAmountMinor: "100400",
};
